
import { GroupAssistantScreenNavigationProps } from "./types"
import React from "react"
import GroupAssistant from "./group-assistant-screen"
import { PageRoot } from "~screens/page-root"


// 群发助手
const SecurityGoogleScreen: React.FC<GroupAssistantScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <GroupAssistant route={route}/>
    </PageRoot>
  )
}

export default SecurityGoogleScreen
